<template lang="pug">
div
  .line-container(@click="openModal")
    img.first(
      src="https://m.hellobike.com/resource/helloyun/08345/zatT280z_l.png?x-oss-process=image/quality,q_80"
    )
    .first-top-block
      .first-top-block-title 生活出行卡券
      .first-top-block-info
        div 最高可省
        .red-font {{propTotalAmount||'-'}}
        div 元/月
        .go-detail
          img(
            src="https://m.hellobike.com/resource/helloyun/08345/TbmIThIT-W.png"
          )
    .one-line-block
      .one-line-block-title
        img(v-if="newCustomer"
          src="https://m.hellobike.com/resource/helloyun/08345/3NycOoj4S2.png"
        )
        img(v-else
          src='https://m.hellobike.com/resource/helloyun/08345/6be_1umVqq.png'
        )
        .one-line-block-title.word {{groupList[0].title}}
      .one-line-block-card
        .one-line-block-card-block(v-for="(item, index) in firstList")
          .one-block-info
            .big-word-font {{(item.propType!==4&&item.propType!==7)?item.amount:item.propTimes}}
            .small-word-font {{(item.propType!==4&&item.propType!==7)?item.unit:'次'}}
          .one-block-middle-info {{item.propType === 4?`${item.propEffectiveDays}天可用`:item.subtitle}}
          .one-block-bottom-info {{item.goodsPropDesc}}
    .two-line-block
      .two-line-block-title
        img(
          src="https://m.hellobike.com/resource/helloyun/08345/6Big75fJnO.png"
        )
        .two-line-block-title.word {{groupList[1].title}}
      .two-line-block-card
        .two-line-block-card-block(v-for="(item, index) in secondList")
          .two-block-info
            .big-word-font {{item.amount}}
            .small-word-font {{item.unit}}
          .two-block-middle-info 含{{ item.propNum||'-' }}张券
          .two-block-bottom-info {{item.title}}
  lifeGoCard(ref="lifeCard" :groupList="groupList"
  :ladderPropGroupList="ladderPropGroupList"
  :ladderDetailMap="ladderDetailMap"
  :newCustomer="newCustomer")
</template>
<script>
import { getNoScroll } from '@/utils';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import lifeGoCard from './life-go-card.vue';


export default {
  components: {
    lifeGoCard,
  },
  props: {
    propTotalAmount: {
      type: String,
      required: true,
    },
    groupList: {
      type: Array,
      required: true,
    },
    ladderPropGroupList: {
      type: Array,
      required: true,
    },
    ladderDetailMap: {
      type: Object,
      required: true,
    },
    newCustomer: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      showLife: false,
      isNew: null,
    };
  },
  computed: {
    firstList() {
      return this.groupList[0].coupons.slice(0, 4);
    },
    secondList() {
      return this.groupList[1].coupons.slice(0, 4);
    },
  },
  methods: {
    openModal() {
      getNoScroll(true);
      this.$refs.lifeCard.open();
      UBT.clickButton({
        pageId: 'platform_savemoneycard_page',
        buttonName: 'platform_copuon_card',
        categoryId: 'platform',
        businessInfo: {},
      });
    },
  },
};
</script>

<style lang="less" scoped>
.line-container {
  margin: 0 0.12rem 0.1rem 0.12rem;
  // background: #fff;
  box-shadow: 0 0.02rem 0.04rem 0 rgba(241, 241, 241, 0.53);
  border-radius: 0.12rem;
  height: 3.14rem;
  padding: 0.08rem 0 0.14rem 0.12rem;
  position: relative;

  img.first {
    position: absolute;
    top: 0;
    left: 0;
    width: 0.44rem;
    height: 0.37rem;
  }

  .first-top-block {
    display: flex;
    justify-content: space-between;

    .first-top-block-title {
      margin-left: 0.18rem;
      font-size: 0.16rem;
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-weight: 500;
      color: #242729;
    }

    .first-top-block-info {
      padding-right: 0.12rem;
      font-size: 0.13rem;
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-weight: 400;
      color: #531900;
      line-height: 0.18rem;
      display: flex;

      .red-font {
        font-size: 0.16rem;
        font-family: PingFangSC-Semibold, PingFang SC, sans-serif;
        font-weight: 600;
        color: #fa4614;
        margin: 0 0.01rem;
      }
    }

    .go-detail {
      margin-left: 0.04rem;

      img {
        width: 0.05rem;
        height: 0.09rem;
      }
    }
  }

  .one-line-block {
    margin-top: 0.18rem;
    line-height: 0.2rem;
    font-size: 0.14rem;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    font-weight: 400;
    color: #242729;

    .one-line-block-title {
      display: flex;

      img {
        width: 0.62rem;
        height: 0.2rem;
      }

      .word {
        margin-left: 0.08rem;
      }
    }

    .one-line-block-card {
      margin-top: 0.12rem;
      padding-right: 0.13rem;
      display: flex;
      justify-content: space-between;

      .one-line-block-card-block {
        width: 0.76rem;
        height: 0.84rem;
        background-image: url(https://m.hellobike.com/resource/helloyun/08345/bDgbQQmtBA.png);
        background-size: 100% 100%;

        .one-block-info {
          text-align: center;
          display: flex;
          justify-content: center;

          .big-word-font {
            margin-top: 0.03rem;
            font-size: 0.26rem;
            font-family: DINAlternate-Bold, DINAlternate, sans-serif;
            font-weight: bold;
            color: #f54311;
            line-height: 0.3rem;
          }

          .small-word-font {
            margin-top: 0.12rem;
            font-size: 0.11rem;
            font-family: PingFangSC-Regular, PingFang SC, sans-serif;
            font-weight: 400;
            color: #f54311;
            margin-left: 0.01rem;
          }
        }

        .one-block-middle-info {
          text-align: center;
          font-size: 0.11rem;
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          font-weight: 400;
          color: #b16652;
          line-height: 0.16rem;
        }

        .one-block-bottom-info {
          text-align: center;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          font-weight: 400;
          color: #fef8ea;
          line-height: 20px;
          margin-top: 0.12rem;
        }
      }
    }
  }

  .two-line-block {
    margin-top: 0.2rem;
    line-height: 0.2rem;
    font-size: 0.14rem;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    font-weight: 400;
    color: #242729;

    .two-line-block-title {
      display: flex;

      img {
        width: 0.62rem;
        height: 0.2rem;
      }

      .word {
        margin-left: 0.08rem;
      }
    }

    .two-line-block-card {
      margin-top: 0.12rem;
      padding-right: 0.13rem;
      display: flex;
      justify-content: space-between;

      .two-line-block-card-block {
        width: 0.76rem;
        height: 0.84rem;
        background-image: url(https://m.hellobike.com/resource/helloyun/08345/mKBiZEHMJy.png);
        background-size: 100% 100%;

        .two-block-info {
          text-align: center;
          display: flex;
          justify-content: center;

          .big-word-font {
            margin-top: 0.08rem;
            font-size: 0.24rem;
            font-family: DINAlternate-Bold, DINAlternate, sans-serif;
            font-weight: bold;
            color: #f54311;
            line-height: 0.3rem;
          }

          .small-word-font {
            margin-top: 0.16rem;
            font-size: 0.11rem;
            font-family: PingFangSC-Regular, PingFang SC, sans-serif;
            font-weight: 400;
            color: #f54311;
            margin-left: 0.01rem;
          }
        }

        .two-block-middle-info {
          margin-top: -0.03rem;
          text-align: center;
          font-size: 0.11rem;
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          font-weight: 400;
          color: #b16652;
          line-height: 0.16rem;
        }

        .two-block-bottom-info {
          text-align: center;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          font-weight: 400;
          color: #fef8ea;
          line-height: 20px;
          margin-top: 0.1rem;
        }
      }
    }
  }
}
</style>
